import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../utils/api';
import { useTranslation } from 'react-i18next';
import './LinkCoachPage.css';

const LinkCoachPage = () => {
  const [coachCode, setCoachCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [linked, setLinked] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLink = async () => {
    if (!coachCode.trim()) return;
    setLoading(true);
    try {
      const res = await apiFetch("/api/coach/link", {
        method: "POST",
        body: JSON.stringify({ code: coachCode.trim() })
      });
      if (!res.ok) throw new Error(t('link_coach.error_code'));
      setLinked(true);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (linked) {
    return (
      <div className="page-container animate-fade-in link-coach-success">
        <div className="link-coach-icon">
          <UserCheck size={48} color="var(--primary)" />
        </div>
        <h2 className="link-coach-title">{t('link_coach.success_title')}</h2>
        <p className="link-coach-desc">
          {t('link_coach.success_desc')}
        </p>
        <button className="btn btn-primary w-full" onClick={() => navigate('/dashboard')}>
          {t('link_coach.back_home')}
        </button>
      </div>
    );
  }

  return (
    <div className="page-container animate-fade-in">
      <div className="header">
        <button className="btn btn-sm btn-secondary" onClick={() => navigate(-1)}>
          {t('common.back')}
        </button>
        <h1 className="header-title">{t('link_coach.title')}</h1>
      </div>

      <div className="link-coach-hero">
        <div className="link-coach-icon">
          <UserCheck size={40} color="var(--primary)" />
        </div>
        <p className="link-coach-desc">
          {t('link_coach.desc')}
        </p>
      </div>

      <div className="card">
        <div className="input-group">
          <label className="input-label">{t('link_coach.code_label')}</label>
          <input
            className="input link-coach-input"
            placeholder={t('link_coach.code_placeholder')}
            value={coachCode}
            onChange={(e) => setCoachCode(e.target.value.toUpperCase())}
            onKeyDown={(e) => e.key === 'Enter' && handleLink()}
            autoCapitalize="characters"
          />
        </div>

        <button
          className="btn btn-primary w-full"
          onClick={handleLink}
          disabled={loading || !coachCode.trim()}
        >
          {loading ? t('link_coach.linking') : t('link_coach.link_btn')}
        </button>
      </div>
      
    </div>
  );
};

export default LinkCoachPage;
